/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// Reexport jen potřebných částí pro zmenšení velikosti bundle.
export { init, getCurrentHub } from '@sentry/browser';

/**
 * Hlavní modul Sentry API pro použití v prostředí webového prohlížeče.
 *
 * Zdroje:
 * - [Github](https://github.com/getsentry/sentry-javascript/tree/master/packages/browser)
 * @interface SentryBrowser
 */
